export default "/_next/static/images/8048feae9050eb4095ff75eeb4d4ec93.jpg";